<br>
<mat-drawer-container class="drawer-container" [hasBackdrop]="true">
    <mat-drawer class="drawer-sidenav" #rightSideNav mode="over" position="end">
        <ng-container *ngIf="student">
            <search-sidenav [student]="student"></search-sidenav>
        </ng-container>
    </mat-drawer>
    <mat-drawer-content>
        <div class="row" style="padding-left: 10px;">
            <div class="col-sm-10">
                <mat-form-field style="display:flex;flex-direction: column">
                    <mat-label>Search by Name [Last, First] or Institution ID</mat-label>
                    <input matInput maxlength="25" autofocus="true" id="txtSearch" (keyup.enter)="search()" autocomplete="off" [disabled]="disableInput" placeholder="Search by Name [Last, First] or Institution ID." #input>
                    <mat-icon (click)="search()" matSuffix>search</mat-icon>
                </mat-form-field>
                <div style="width: 100%;">
                    <mat-table matSort matSortActive="lastSeason" matSortDirection="desc" matSortDisableClear
                        [dataSource]="dataSource" style="width: 100%;">
                        <ng-container matColumnDef="institutionId">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Institution ID </mat-header-cell>
                            <mat-cell mat-cell *matCellDef="let element">
                                {{element.institutionId | mask: '00-000-0000'}}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="workdayId">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>Workday ID </mat-header-cell>
                            <mat-cell *matCellDef="let element">{{element.workdayId}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="lastName">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>Last Name </mat-header-cell>
                            <mat-cell *matCellDef="let element">{{element.lastName}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="firstName">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>First Name </mat-header-cell>
                            <mat-cell *matCellDef="let element">{{element.firstName}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="middleName">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>Middle Name </mat-header-cell>
                            <mat-cell *matCellDef="let element">{{element.middleName}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="collegeName">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> College Name </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element.collegeName}}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="primarySport">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Primary Sport </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element.primarySport}} </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="lastSeason">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Last Season </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element.lastSeason}} </mat-cell>
                        </ng-container>                       
                        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                        <mat-row matRipple [ngClass]="{'row_select': this.student!=null && row.studentId === this.student.studentId }" *matRowDef="let row; columns: displayedColumns;" (click)="view(row)"></mat-row>
                    </mat-table>
                    <mat-paginator [length]="studentCount" [pageSizeOptions]="[15,20,30,40,50,100]"></mat-paginator>
                </div>
            </div>
           <div class="col-sm-2" *ngIf="AddStudent">
                    <button (click)="openDialog()" class="mb-2" style="float: right;" mat-raised-button
                        color="primary">
                        Add Student
                    </button>
            </div>
        </div>
    </mat-drawer-content>
</mat-drawer-container>
